import React from "react";
import { Outlet } from "react-router-dom";

const EventsWrapper: React.FC = () => {
  return <Outlet />;
};

export default EventsWrapper;
